import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Row } from "@/components/settings/parts";
import { errMsg, useApi } from "@/lib/api";

const FIELDS = [
  ["account_id", "Account ID", "32 caratteri: pagina principale dell'account, colonna destra"],
  ["zone_id", "Zone ID", "32 caratteri: pagina Panoramica del dominio"],
  ["domain", "Dominio della piattaforma", "Es. tuodominio.com"],
];

export default function CloudflareFields({ h, onChange }) {
  const api = useApi();
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { setF({ ...h.cloudflare, preview_suffix: h.preview_suffix }); }, [h]);
  if (!f) return null;
  const dirty = FIELDS.some(([k]) => f[k] !== h.cloudflare[k]) || f.preview_suffix !== h.preview_suffix;
  const save = async () => {
    setBusy(true);
    try { const { data } = await api.put("/hosting", { mode: "cloudflare", ...f, live_suffix: h.live_suffix }); onChange(data); toast.success("Dati Cloudflare salvati"); }
    catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div className="space-y-4" data-testid="hosting-cf-fields">
      {FIELDS.map(([k, label, hint]) => (
        <Row key={k} label={label} hint={hint}>
          <Input value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value.trim().toLowerCase() })} className="max-w-md font-mono text-sm" spellCheck={false} data-testid={`hosting-cf-${k}`} />
        </Row>
      ))}
      <Row label="Suffisso anteprima" hint="trattoria + suffisso + dominio">
        <Input value={f.preview_suffix} onChange={(e) => setF({ ...f, preview_suffix: e.target.value.trim().toLowerCase() })} className="max-w-[180px] font-mono text-sm" data-testid="hosting-cf-preview-suffix" />
      </Row>
      <div className="flex justify-end"><Button onClick={save} disabled={!dirty || busy} className="bg-sky-600 hover:bg-sky-700" data-testid="hosting-cf-save">{busy && <Loader2 size={14} className="mr-1.5 animate-spin" />}Salva dati Cloudflare</Button></div>
    </div>
  );
}
